import { Box, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const TextComponent = ({
    kriterId,
    kriterAdi,
    parentKriterId,
    parentSecenekId = null,
    selKriterler,
    bagliOlunanKriterId,
    bagliOlunanKriterSecenekId,
    zorunlu = false,
    onChange }) => {

    const [visiable, setVisiable] = useState(true);

    useEffect(() => {

        if (bagliOlunanKriterId) {
            const isVisible =
                bagliOlunanKriterSecenekId &&
                selKriterler &&
                selKriterler[bagliOlunanKriterId]?.value === bagliOlunanKriterSecenekId;
            setVisiable(!!isVisible);

        } else {
            setVisiable(true);

        }


    }, [bagliOlunanKriterId, bagliOlunanKriterSecenekId, selKriterler]);


    if (visiable === false)
        return <></>

    return <Box sx={{ pt: 2 }}>
        <TextField
            key={kriterId}
            label={
                <span>
                    {kriterAdi}
                    {zorunlu && <span style={{ color: "red", fontSize: "1.3rem", fontWeight: "bold" }}> *</span>}
                </span>
            }
            variant='outlined'
            margin='dense'
            InputLabelProps={{ shrink: true }}
            defaultValue={selKriterler[kriterId]?.value || ""}
            fullWidth
            onChange={(event) => {
                onChange(kriterId, event.target.value || "");
            }}
        />
    </Box>



}

export default TextComponent;